import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoContent from '../../../components/common/InfoContent';
import Modal from '../../../components/common/Modal';
import UpdateCardModal from '../../../components/common/UpdateCardModal';
import Config from '../../../Config';
import { useCartContext } from '../../../context/CartContext';
import { useGlobalContext } from '../../../context/GlobalContext';
import { usePayment } from '../../../context/PaymentContext';
import ClientId from '../services/ClientId';
import PaymentFormLocal from '../services/PaymentFormLocal';
import TaxId from '../services/TaxtId';
import AccessibleContent from '../../../utils/AccessibleContent';
import { validateTaxId, validateVAT } from '../../../utils/validationClient';
import { formatDateTime } from '../../../utils/DateUtils';

import VAT from '../services/Vat';

const Step2 = ({ step, selectedStore, lang }) => {
  const { t } = useTranslation();
  const { formatAmounts, store, user, validateClientId, goToStep } = useGlobalContext();
  const {
    cart,
    totalAmounts,
    totalAmountsAfterDiscount,
    totalPort,
    totalFinal,
    deleteRequestCartItem,
    selectOption,
    selectDelivery,
    isDeliveryDisabled,
    filterDeliveriesByWeight,
    generateCartItemsByAddress,
    generateCartItemsByAmount,
    calcCartTotals,
    haveDiscount,
    cartDiscountCondition,
    discountType,

  } = useCartContext();
  const { createOrder, checkTransaction, handlePayment, pspType, paymentHtml } = usePayment();
  const [infoField, setInfoField] = useState('');
  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [modalUpdateOpen, setModalUpdateOpen] = useState(false);
  const [modalUpdateType, setModalUpdateType] = useState(null); // 'update' ou 'copy'
  const [cardToUpdate, setCardToUpdate] = useState(null);
  const [cardIndex, setCardIndex] = useState(null);
  // Cart states
  const orderCardByAmountInCart = store?.orderByAmountInCart || false;
  // Form states
  const [userData, setUserData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    confEmail: '',
    phone: '',
    accepteCGV: false,
    accepteNL: false,
    allowTD: false,
    // KYC fields
    kyc_address_1: '',
    kyc_address_2: '',
    kyc_address_3: '',
    kyc_address_4: '',
    kyc_postalCode: '',
    kyc_city: '',
    kyc_state: '',
    kyc_country: '',
    // Invoice fields
    isGettingInvoiceActivated: store.sending_invoice_activated === 2,
    taxId: '',
    vat: '',
    companyTransmitter: '',
    addressTransmitter: '',
    addressComplementTransmitter: '',
    addressComplementTransmitter1: '',
    addressComplementTransmitter2: '',
    postalCode: '',
    city: '',
    country: store.country || ''
  });

  const [formErrors, setFormErrors] = useState({
    isRequiredMsg: '',
    isEmaildMsg: '',
    isEqualToMsg: '',
    isValidDeliveries: '',
    isValidProIdentification: '',
    exceptionMsg: ''
  });

  const showDateSend = (item) => item.sendDate && !item.isSelfDestination;



  const handleDeleteClick = (key) => {
    setItemToDelete(key);
    setModalType('delete');
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  useEffect(() => {
    if (cart.items) {
      if (selectedStore === 'physical') {
        generateCartItemsByAddress(store);
      } else if (orderCardByAmountInCart) {
        generateCartItemsByAmount(store);
      }
      calcCartTotals(store);
    }
  }, [cart.items]);


  const handleUpdateClick = (card, index) => {
    setModalUpdateType('update');
    setCardToUpdate(card);
    setCardIndex(index);
    setModalUpdateOpen(true);
  };
  const handleCopyClick = (card, index) => {
    setModalUpdateType('copy');
    setCardToUpdate(card);
    setCardIndex(index);
    setModalUpdateOpen(true);
  };
  useEffect(() => {
    if (pspType === 'local-form') {
      // Ajouter jQuery si nécessaire
      if (!window.jQuery) {
        const jqueryScript = document.createElement('script');
        jqueryScript.src = "https://code.jquery.com/jquery-3.6.0.min.js";
        jqueryScript.async = true;
        jqueryScript.onload = () => {
          console.log("jQuery loaded");
        };
        document.head.appendChild(jqueryScript);
      }
    }
  }, [pspType]);
  const getStateName = (state) => {
    if (!state?.names) return '';
    return (
      state.names[lang] ||
      state.names[store.default_language] ||
      state.names[Object.keys(state.names)[0]]
    ) + ` (${state.code})`;
  };
  const handleShowInfo = (field) => {
    setInfoField(field);
  };

  const handleHideInfo = () => {
    setInfoField('');
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (store.isProSignboard) {
      if (!userData.proIdentification) {
        errors.proIdentification = t("L'identifiant de société est obligatoire");
        isValid = false;
      }
    } else {
      // User information validation
      if (!userData.firstname) {
        errors.firstname = t("Le prénom est obligatoire");
        isValid = false;
      } else if (userData.firstname.length > 25) {
        errors.firstname = t("Votre prénom ne doit pas dépasser 25 caractères");
        isValid = false;
      }
      if (store.codeTaxId) {
        const isTaxIdOptional = store.tax_id_optional ||
          (store.tax_id_position === 1 && !userData.isGettingInvoiceActivated);

        if (!isTaxIdOptional || (userData.taxId && userData.taxId.trim() !== '')) {
          if (!userData.taxId && !isTaxIdOptional) {
            errors.taxId = t("L'identifiant fiscal est obligatoire");
            isValid = false;
          } else if (userData.taxId && userData.taxId.trim() !== '') {
            const isTaxIdValid = validateTaxId(
              userData.taxId,
              store.codeTaxId,
              { isOptional: isTaxIdOptional }
            );

            if (!isTaxIdValid) {
              errors.taxId = t("Le format de la TVA n'est pas valide");
              isValid = false;
            }
          }
        }
      }
      if (store.vatEnabled) {
        const isVatOptional = store.vat_optional ||
          (store.vat_position === 1 && !userData.isGettingInvoiceActivated);

        if (!isVatOptional && !userData.vat) {
          errors.vat = t("Le numéro de TVA est obligatoire");
          isValid = false;
        } else if (userData.vat && userData.vat.trim() !== '') {
          if (store.validateVat && !validateVAT(userData.vat, userData.country)) {
            errors.vat = t("Le format du numéro de TVA n'est pas valide");
            isValid = false;
          }
        }
      }
      if (!userData.lastname) {
        errors.lastname = t("Le nom est obligatoire");
        isValid = false;
      } else if (userData.lastname.length > 25) {
        errors.lastname = t("Votre nom ne doit pas dépasser 25 caractères");
        isValid = false;
      }

      if (!userData.email) {
        errors.email = t("L'email est obligatoire");
        isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(userData.email)) {
        errors.email = t("Veuillez saisir un email valide");
        isValid = false;
      }

      if (!userData.confEmail) {
        errors.confEmail = t("La confirmation d'email est obligatoire");
        isValid = false;
      } else if (userData.email !== userData.confEmail) {
        errors.confEmail = t("Les emails renseignés sont différents");
        isValid = false;
      }

      if (store.clientIdType) {
        const isClientIdOptional = store.isClientIdOptional === true;

        if (!isClientIdOptional || (userData.clientId && userData.clientId.trim() !== '')) {
          if (!userData.clientId && !isClientIdOptional) {
            errors.clientId = t("Le numéro de carte IKEA est obligatoire");
            isValid = false;
          }
          else if (userData.clientId && userData.clientId.trim() !== '') {
            const isClientIdValid = validateClientId(userData.clientId);

            if (!isClientIdValid) {
              errors.clientId = t("Numéro de carte IKEA invalide");
              isValid = false;
            }
          }
        }
      }

      if (store.phone_enabled) {
        if (!userData.phone) {
          errors.phone = t("Le numéro de téléphone est obligatoire");
          isValid = false;
        } else if (store.phone_regex && !new RegExp(store.phone_regex).test(userData.phone)) {
          errors.phone = t("Format de téléphone invalide");
          isValid = false;
        }
      }

      // KYC Validation
      if (store.kycEnabled && store.kycs?.buyer_address &&
        totalAmounts >= store.kycs.buyer_address.thresholdPrice) {
        if (!userData.kyc_address_1) {
          errors.kyc_address_1 = t("L'adresse est obligatoire");
          isValid = false;
        }
        if (!userData.kyc_postalCode) {
          errors.kyc_postalCode = t("Le code postal est obligatoire");
          isValid = false;
        }
        if (!userData.kyc_city) {
          errors.kyc_city = t("La ville est obligatoire");
          isValid = false;
        }
        if (!userData.kyc_country) {
          errors.kyc_country = t("Le pays est obligatoire");
          isValid = false;
        }
      }

      // Invoice validation if activated
      if (userData.isGettingInvoiceActivated) {
        if (store.sending_invoice_activated === 3 && !userData.companyTransmitter) {
          errors.companyTransmitter = t("Le nom de l'entreprise est obligatoire");
          isValid = false;
        }
        if (!userData.addressTransmitter) {
          errors.addressTransmitter = t("L'adresse de facturation est obligatoire");
          isValid = false;
        }
        if (!userData.postalCode) {
          errors.postalCode = t("Le code postal est obligatoire");
          isValid = false;
        }
        if (!userData.city) {
          errors.city = t("La ville est obligatoire");
          isValid = false;
        }
        if (!userData.country) {
          errors.country = t("Le pays est obligatoire");
          isValid = false;
        }
      }

      // Terms and conditions
      if (!userData.accepteCGV) {
        errors.accepteCGV = t("Veuillez accepter les conditions générales");
        isValid = false;
      }
    }

    setFormErrors(errors);
    return isValid;
  };
  const FieldError = ({ error, id }) => {
    if (!error) return null;

    return (
      <div className="field-error" id={`error-${id}`} role="alert">
        <span className="error-icon" aria-hidden="true">⚠️</span>
        <span className="error-message">{error}</span>
      </div>
    );
  };
  useEffect(() => {
    if (pspType === 'local-form' && paymentHtml) {
      // Injecter le HTML
      const container = document.getElementById('payment-local-container');
      if (container) {
        container.innerHTML = paymentHtml;

        // Injecter les scripts dynamiquement
        const scripts = container.getElementsByTagName('script');
        Array.from(scripts).forEach(oldScript => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(attr => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }
    }
  }, [pspType, paymentHtml]); // Déclenché quand le type PSP ou le HTML change
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      // Préparation des cartes avec les données appropriées
      const formattedCards = cart.items.map(item => {
        const baseCard = {
          card: item.card,
          signboardId: store.id,
          visualId: item.visualId,
          message: item.message || "",
          amount: item.amount,
          firstNameReceiver: item.firstNameReceiver,
          lastNameReceiver: item.lastNameReceiver,
          emailReceiver: item.isSelfDestination ? userData.email : item.emailReceiver,
          isSelfDestination: item.isSelfDestination,
          sendDate: item.sendDate,
          sendDateTmp: item.sendDateTmp,
          cgv: true,
          receiveInfos: userData.accepteNL ? "1" : "0",
          qty: item.qty || 1,
          momentSend: item.momentSend,
          cardLanguage: item.cardLanguage || lang,
          isGettingInvoiceActivated: userData.isGettingInvoiceActivated,
          isGettingLivstickVideo: false,
          firstNameSender: userData.firstname,
          lastNameSender: userData.lastname,
          emailSender: userData.email,
          phoneSender: userData.phone,
          clientId: userData.clientId || null
        };

        if (selectedStore === 'physical') {
          // Recréer l'objet physical avec toutes les propriétés requises
          baseCard.physical = {
            address_1: item.physical?.address_1,
            address_2: item.physical?.address_2,
            address_3: item.physical?.address_3,
            address_4: item.physical?.address_4,
            city: item.physical?.city,
            zip: item.physical?.zip,
            country: item.physical?.country,
            state: item.physical?.state,
            state_code: item.physical?.state_code
          };

          // Générer la clé d'adresse pour récupérer les options et livraisons
          const address = [
            item.firstNameReceiver,
            item.lastNameReceiver,
            item.physical?.address_1,
            item.physical?.address_2,
            item.physical?.address_3,
            item.physical?.address_4,
            item.physical?.zip,
            item.physical?.city,
            item.physical?.country
          ].join('_').replace(/[^a-zA-Z0-9_]/g, '-');

          // Ajouter l'ID de livraison et l'option si disponibles
          if (cart.delivery && cart.delivery[address]) {
            baseCard.delivery = cart.delivery[address].id;
          }

          if (cart.option && cart.option[address]) {
            // Trouver la première option active
            const activeOptionKey = Object.keys(cart.option[address]).find(key =>
              cart.option[address][key] === true
            );

            if (activeOptionKey) {

              // Trouver l'option correspondante dans le store pour obtenir son anchor
              if (store?.physical_store?.card_options && Array.isArray(store.physical_store.card_options)) {
                // Si activeOptionKey est un index numérique et qu'il est valide
                const optionIndex = parseInt(activeOptionKey, 10);
                if (!isNaN(optionIndex) && optionIndex < store.physical_store.card_options.length) {
                  const option = store.physical_store.card_options[optionIndex];

                  // Utiliser l'anchor comme valeur pour baseCard.option
                  if (option.anchor) {
                    baseCard.option = option.anchor;
                  }
                }
              }
            }
          }
        }

        // Ajout des champs KYC seulement si KYC est activé
        if (store.kycEnabled && store.kycs?.buyer_address &&
          totalAmounts >= store.kycs.buyer_address.thresholdPrice) {
          Object.assign(baseCard, {
            address1Sender: userData.kyc_address_1,
            address2Sender: userData.kyc_address_2,
            address3Sender: userData.kyc_address_3,
            address4Sender: userData.kyc_address_4,
            postalCodeSender: userData.kyc_postalCode,
            citySender: userData.kyc_city,
            stateSender: userData.kyc_state,
            countrySender: userData.kyc_country,
          });
        }

        // Ajout des champs de facturation seulement si activé
        if (userData.isGettingInvoiceActivated) {
          Object.assign(baseCard, {
            taxId: userData.taxId,
            vat: userData.vat,
            addressTransmitter: userData.addressTransmitter,
            addressComplementTransmitter: userData.addressComplementTransmitter,
            postalCode: userData.postalCode,
            city: userData.city,
            country: userData.country,
            companyTransmitter: userData.companyTransmitter
          });
        }




        return baseCard;
      });

      const orderData = {
        api_key: Config.api.key,
        store: selectedStore,
        cards: formattedCards,
        lng: lang,
        amex: cart.useAmex || false,
        client: null,
        proIdentification: store.isProSignboard ? userData.proIdentification : null,
        mobile: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? '1' : '0'
      };
      const orderResult = await createOrder(orderData);
      if (orderResult) {
        handlePayment(orderResult.result.Data, orderResult.result.htmlInfo);

      }
    } catch (error) {
      setFormErrors(prev => ({
        ...prev,
        exceptionMsg: error.message
      }));
    }
  };
  useEffect(() => {
    if (cart.items.length === 0 && (step === 2 || step == "payment")) {
      goToStep(1);
    }
  }, [cart.items.length, step]);


  useEffect(() => {
    if (step === 'payment') {
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has('PAYID')) {
        checkTransaction(
          queryParams.get('reference'),
          queryParams.get('status'),
          Object.fromEntries(queryParams.entries())
        );
      }
    }
  }, [step, checkTransaction]);
  if (step !== 2 && step !== 'payment') return null;


  return (
    <div className="mainContent step-2" >
      <div className="wrapper">
        <div className={`store-${selectedStore} ${step === 'payment' ? 'step-payment' : ''}`}>
          <div className="left-column-container" role="main" aria-labelledby="section-heading">
            <h2 id="section-heading" className="sr-only">Détails de votre commande</h2>
            <div className="cardSection2">
              <div className="cartItems">
                {/* En-tête du panier */}
                <div className="cartItemsHead">
                  <div className="itemData panelHeader">
                    <div className="row">
                      <span className="myCart">{t('MON PANIER')}</span>
                      {!orderCardByAmountInCart && (
                        <>
                          <span className="cartQte .typo" >
                            <div className="flex">
                              <span >{t('Quantité :')}</span>
                              <span className="mainColor typoBold">{cart.items?.length || 0}</span>
                            </div>
                            {cartDiscountCondition && discountType === 'discount' && cartDiscountCondition.valueType === 'percent' && (
                              <div className="flex">
                                {t('Remise :')}
                                <span className="mainColor typoBold">&nbsp;-{cartDiscountCondition.value}%</span>
                              </div>
                            )}
                            {cartDiscountCondition && discountType === 'discount' && cartDiscountCondition.valueType === 'amount' && (
                              <div className="flex">
                                {t('Remise :')}
                                <span className="mainColor typoBold">&nbsp;-{formatAmounts(cartDiscountCondition.value, 2)}</span>
                              </div>
                            )}
                          </span>
                          <span className="cartTotal">
                            <div className="flex">
                              {t('Total')} :&nbsp;
              <span className="mainColor typoBold">{formatAmounts(totalAmounts, 2)}</span>
                            </div>
                            {haveDiscount && discountType === 'discount' && (
                              <div className="flex">
                                {t('Total dû')} :&nbsp;
                                <span className="mainColor typoBold">{formatAmounts(totalAmountsAfterDiscount, 2)}</span>
                              </div>
                            )}
                            {haveDiscount && discountType === 'abundance' && (
                              <div className="flex">
                                {t('Valeur réelle')} :&nbsp;
                                <span className="mainColor typoBold">{formatAmounts(totalAmountsAfterDiscount, 2)}</span>
                              </div>
                            )}
                            {selectedStore === 'physical' && (
                              <>
                                <div className="flex">
                                  {t('Frais de port')} :&nbsp;
                  <span className="mainColor typoBold">{formatAmounts(totalPort, 2)}</span>
                                </div>
                                <div className="flex">
                                  {t('Total dû')} :&nbsp;
                  <span className="mainColor typoBold">{formatAmounts(totalFinal, 2)}</span>
                                </div>
                              </>
                            )}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Affichage pour le store digital sans regroupement */}
                {selectedStore === 'digital' && !orderCardByAmountInCart && cart.items?.map((item, index) => (
                  <div key={index} className="cartItem2">
                    <img className="itemPreview" src={item.card || 'placeholder.jpg'} alt="Prévisualisation carte" />
                    <div className="itemData">
                      <div className="iPrice typoBold">
                        <div>{formatAmounts(item.amount, item.amount % 1 ? 2 : 0)}</div>
                        {item.discountCondition && discountType === 'abundance' && item.amount !== item.amountAfterDiscount && (
                          <div className="alignCenter discount-abundance">
                            {item.discountCondition.valueType === 'percent' ? (
                              <>
                                <div>
                                  + {item.discountCondition.value}%<br />
                                  {t('Valeur réelle')} :
                </div>
                                <div className="iPrice">{formatAmounts(item.amountAfterDiscount, 2)}</div>
                              </>
                            ) : (
                                <>
                                  <div>
                                    + {formatAmounts(item.discountCondition.value, 2)}<br />
                                    {t('Valeur réelle')} :
                </div>
                                  <div className="iPrice">{formatAmounts(item.amountAfterDiscount, 2)}</div>
                                </>
                              )}
                          </div>
                        )}
                        {item.discountCondition && discountType === 'discount' && item.amount !== item.amountAfterDiscount && (
                          <div className="alignCenter discount-abundance">
                            {item.discountCondition.valueType === 'percent' ? (
                              <>
                                <div>
                                  - {item.discountCondition.value}%<br />
                                  {t('Montant après remise')} :
                </div>
                                <div className="iPrice">{formatAmounts(item.amountAfterDiscount, 2)}</div>
                              </>
                            ) : (
                                <>
                                  <div>
                                    - {formatAmounts(item.discountCondition.value, 2)}<br />
                                    {t('Montant après remise')} :
                </div>
                                  <div className="iPrice">{formatAmounts(item.amountAfterDiscount, 2)}</div>
                                </>
                              )}
                          </div>
                        )}
                      </div>
                      {!item.isSelfDestination ? (
                        <div className="iSender">
                          {t('Envoyée à :')} {item.emailReceiver}
                        </div>
                      ) : (
                          <>
                            <div className="iSender">
                              {t('Envoyée à :')} {item.firstNameReceiver} {item.lastNameReceiver}
                            </div>
                            <div className="iSender">{t('Remise en main propre')}</div>
                          </>
                        )}
                      {showDateSend(item) && (
                        <div className="iDate">
                          {(() => {
                            const timeData = formatDateTime.formatDisplayTime(item.sendDate, store.format_time);
                            return (
                              <>
                                {t('Le :')} {formatDateTime.formatDisplayDate(item.sendDate, store.format_date)} {t('à')}
                                {timeData.time}<span className="timezone-small">{timeData.timezone}</span>
                              </>
                            );
                          })()}
                        </div>
                      )}
                      <a
                        href="#"
                        className="deleteItem"

                        onClick={(e) => { e.preventDefault(); handleDeleteClick(index); }}
                        aria-label={t('Supprimer cet article')}

                      >
                        <i className="icon-trash" aria-hidden="true"></i>
                        <span className="sr-only">{t('Supprimer cet article')}</span>
                      </a>
                    </div>
                    <div className="cardComment">
                      <p>{item.message}</p>
                    </div>
                  </div>
                ))}

                {/* Affichage groupé par montant pour digital */}
                {selectedStore === 'digital' && orderCardByAmountInCart && Object.entries(cart.itemsByAmount || {}).map(([amount, cards]) => (
                  <div key={amount} className="cartItem2 cartByAmount">
                    <img className="itemPreview" src={cards[0].card || 'placeholder.jpg'} alt="Prévisualisation carte" />
                    <div className="itemData">
                      <div className="iPrice">
                        <div>{formatAmounts(cards[0].amount, cards[0].amount % 1 ? 2 : 0)}</div>
                        {cards[0].discountCondition && discountType === 'abundance' && (
                          <div className="alignCenter discount-abundance">
                            {cards[0].discountCondition.valueType === 'percent' ? (
                              <>
                                <div>
                                  + {cards[0].discountCondition.value}%<br />
                                  {t('Valeur réelle')} :
                </div>
                                <div className="iPrice">
                                  {formatAmounts(cards[0].amountAfterDiscount, 2)}
                                </div>
                              </>
                            ) : (
                                <>
                                  <div>
                                    + {formatAmounts(cards[0].discountCondition.value, 2)}<br />
                                    {t('Valeur réelle')} :
                </div>
                                  <div className="iPrice">
                                    {formatAmounts(cards[0].amountAfterDiscount, 2)}
                                  </div>
                                </>
                              )}
                          </div>
                        )}
                        {cards[0].discountCondition && discountType === 'discount' && (
                          <div className="alignCenter discount-abundance">
                            {cards[0].discountCondition.valueType === 'percent' ? (
                              <>
                                <div>
                                  - {cards[0].discountCondition.value}%<br />
                                  {t('Montant après remise')} :
                </div>
                                <div className="iPrice">
                                  {formatAmounts(cards[0].amountAfterDiscount, 2)}
                                </div>
                              </>
                            ) : (
                                <>
                                  <div>
                                    - {formatAmounts(cards[0].discountCondition.value, 2)}<br />
                                    {t('Montant après remise')} :
                </div>
                                  <div className="iPrice">
                                    {formatAmounts(cards[0].amountAfterDiscount, 2)}
                                  </div>
                                </>
                              )}
                          </div>
                        )}
                      </div>
                      <div className="iQuantity">{t('Quantity: ')} {cards.length}</div>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    <div className="cards">
                      {cards.map((item, idx) => (
                        <div key={idx}>
                          <img className="itemPreview" src={item.card || 'placeholder.jpg'} alt="Prévisualisation carte" />
                          <div className="itemData">
                            {!item.isSelfDestination ? (
                              <div className="iSender">
                                {t('Envoyée à :')} {item.emailReceiver}
                              </div>
                            ) : (
                                <>
                                  <div className="iSender">
                                    {t('Envoyée à :')} {item.firstNameReceiver} {item.lastNameReceiver}
                                  </div>
                                  <div className="iSender">{t('Remise en main propre')}</div>
                                </>
                              )}
                            {showDateSend(item) && (
                        <div className="iDate">
                          {(() => {
                            const timeData = formatDateTime.formatDisplayTime(item.sendDate, store.format_time);
                            return (
                              <>
                                {t('Le :')} {formatDateTime.formatDisplayDate(item.sendDate, store.format_date)} {t('à')}
                                {timeData.time}<span className="timezone-small">{timeData.timezone}</span>
                              </>
                            );
                          })()}
                        </div>
                      )}
                          </div>
                          <div>
                            <a
                              href="#"
                              className="updateCardBtn"
                              onClick={(e) => { e.preventDefault(); handleUpdateClick(item, item.key); }}
                              aria-label={t('Modifier cet article')}

                            >
                              <i className="fa fa-pen" aria-hidden="true"></i>
                              <span className="sr-only">{t('Modifier cet article')}</span>
                            </a>
                            <a
                              href="#"
                              className="deleteItem"
                              onClick={(e) => { e.preventDefault(); handleDeleteClick(item.key); }}
                              aria-label={t('Supprimer cet article')}

                            >
                              <i className="icon-trash" aria-hidden="true"></i>
                              <span className="sr-only">{t('Supprimer cet article')}</span>
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                    {cards.length < 10 && (
                      <div className="copyCard">
                        <span className="infoAnotherCard">{t('You want to send this card to more people ?')}</span>
                        <a
                          href="#"
                          className="btn buyOther btnAnotherCard"
                          onClick={(e) => { e.preventDefault(); handleCopyClick(cards[0], cards[0].key); }}
                        >
                          {t('Add another card')}
                        </a>
                      </div>
                    )}
                  </div>
                ))}

                {/* Affichage pour le store physique */}
                {selectedStore === 'physical' && Object.entries(cart.itemsByAddress || {}).map(([keyCart, cards]) => (
                  <div key={keyCart} className="cartItem2 cartPhysical mainColor">
                    {cards.map((item, idx) => (
                      <div key={idx}>
                        <img className="itemPreview" src={item.card || 'placeholder.jpg'} alt="Prévisualisation carte" />
                        <div className="itemData">
                          <div className="iPrice">{formatAmounts(item.amount)}</div>
                          <a
                            href="#"
                            className="deleteItem"
                            onClick={(e) => { e.preventDefault(); handleDeleteClick(item.key); }}
                            aria-label={t('Supprimer cet article')}

                          >
                            <i className="icon-trash" aria-hidden="true"></i>
                            <span className="sr-only">{t('Supprimer cet article')}</span>
                          </a>
                        </div>
                        <div className="cardComment"><p>{item.message}</p></div>
                      </div>
                    ))}
                    <div className="cartAddress">
                      <span className="title">{t('Adresse de livraison')}:</span>
                      <span>
                        {cards[0].firstNameReceiver} {cards[0].lastNameReceiver}<br />
                        {cards[0].physical?.address_1}<br />
                        {cards[0].physical?.address_2 && (<>{cards[0].physical.address_2}<br /></>)}
                        {cards[0].physical?.address_3 && (<>{cards[0].physical.address_3}<br /></>)}
                        {cards[0].physical?.zip} {cards[0].physical?.city}<br />
                        {cards[0].physical?.state && (<>{cards[0].physical.state}<br /></>)}
                        {cards[0].physical?.country}
                      </span>
                    </div>
                    <div className="cartOptions">
                      {store.physical_store?.card_options?.length > 0 && (
                        <div className="title">{t('Options')}:</div>
                      )}
                      {store.physical_store?.card_options
                        ?.filter(option => option.card_count_min <= cards.length && option.card_count_max >= cards.length)
                        .map((option, keyOption) => (
                          <div key={keyOption} className="cartOption">
                            <span>
                              <a className="mainColor" href={`/options#${option.anchor}`}>
                                {option.name}
                              </a>
                            </span>
                            <span>{formatAmounts(option.price, 2)}</span>
                            <span>
                              <input
                                type="checkbox"
                                onChange={() => selectOption(keyCart, keyOption)}
                                checked={cart.option?.[keyCart]?.[keyOption] || false}
                                name={`option[${keyCart}][${keyOption}]`}
                                value="1"
                              />
                            </span>
                          </div>
                        ))}
                    </div>
                    <div className="cartDelivery">
                      <label className="title" htmlFor={`delivery_${keyCart}`}>
                        {t('Choisir le mode de livraison')}
                      </label>
                      <select
                        id={`delivery_${keyCart}`}
                        onChange={(e) => selectDelivery(keyCart, e.target.value)}
                        required
                        name={`delivery[${keyCart}]`}
                        value={cart.delivery[keyCart]?.id || ''}
                      >
                        {store.physical_store?.deliveries
                          ?.filter(delivery => filterDeliveriesByWeight(keyCart)(delivery))
                          .map(delivery => (
                            <option
                              key={delivery.id}
                              value={delivery.id}
                              disabled={isDeliveryDisabled(delivery, keyCart)}
                            >
                              {delivery.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <AccessibleContent
              htmlContent={store.mentionLegale[lang]}
              className="bottomSection2-step2 mainColor"
            />
          </div>
          {/* Section "Vos coordonnées" */}
          <div className="orderSection">
            {orderCardByAmountInCart && (
              <section className="orderRecap" aria-labelledby="order-summary-title">
                <h2 id="order-summary-title" className="sr-only">{t('Récapitulatif de la commande')}</h2>
                <>
                  <span className="cartTotal">
                    <div className="flex">
                      {t('Total')} :&nbsp;
                  <span className="mainColor">{formatAmounts(totalAmounts, 2)}</span>
                    </div>
                    {haveDiscount && discountType === 'discount' && (
                      <div className="flex">
                        {t('Total dû')} :&nbsp;
                        <span className="mainColor">{formatAmounts(totalAmountsAfterDiscount, 2)}</span>
                      </div>
                    )}
                    {haveDiscount && discountType === 'abundance' && (
                      <div className="flex">
                        {t('Valeur réelle')} :&nbsp;
                        <span className="mainColor">{formatAmounts(totalAmountsAfterDiscount, 2)}</span>
                      </div>
                    )}
                    {selectedStore === 'physical' && (
                      <>
                        <div className="flex">
                          {t('Frais de port')} :&nbsp;
                      <span className="mainColor">{formatAmounts(totalPort, 2)}</span>
                        </div>
                        <div className="flex">
                          {t('Total dû')} :&nbsp;
                      <span className="mainColor">{formatAmounts(totalFinal, 2)}</span>
                        </div>
                      </>
                    )}
                  </span>
                  <span className="cartQte">
                    <div className="flex">
                      {t('Quantité :')}
                      <span className="mainColor">&nbsp;{cart.items?.length || 0}</span>
                    </div>
                    {cartDiscountCondition && discountType === 'discount' && cartDiscountCondition.valueType === 'percent' && (
                      <div className="flex">
                        {t('Remise :')}
                        <span className="mainColor">&nbsp;-{cartDiscountCondition.value}%</span>
                      </div>
                    )}
                    {cartDiscountCondition && discountType === 'discount' && cartDiscountCondition.valueType === 'amount' && (
                      <div className="flex">
                        {t('Remise :')}
                        <span className="mainColor">&nbsp;-{formatAmounts(cartDiscountCondition.value, 2)}</span>
                      </div>
                    )}
                  </span>
                </>
              </section>)}
            {step !== 'payment' && (
              <form method="post" name="formCreateOrder" id="formCreateOrder" noValidate onSubmit={handleSubmit}>
                <div className="mainCol">
                  <div className="whiteBox" role="region" aria-labelledby="contact-info-heading">
                    <div className="stepBox">
                      <div className="formBox2">
                        <h2 className="fieldsGroupHead alignCenter" id="contact-info-heading" style={{ padding: 0 }}>{t('Vos coordonnées')}</h2>
                        <div className="fieldsGroup">
                          {/* Champs standard pour non-pro */}
                          {!store.isProSignboard && (
                            <>
                              <div className="formField">
                                <div className="formControl">
                                  <input
                                    type="text"
                                    name="firstname"
                                    id="firstname"
                                    required
                                    value={userData.firstname}
                                    onChange={handleInputChange}
                                    placeholder={t('Prénom') + '*'}
                                    aria-label={t("Prénom")}
                                    className={formErrors.firstname ? 'error' : ''}
                                    aria-invalid={formErrors.firstname ? 'true' : 'false'}
                                    aria-describedby={formErrors.firstname ? 'error-firstname' : undefined}
                                  />
                                </div>
                                {formErrors.firstname && <FieldError error={formErrors.firstname} id="firstname" />}
                              </div>
                              <div className="formField">
                                <div className="formControl">
                                  <input
                                    type="text"
                                    name="lastname"
                                    id="lastname"
                                    value={userData.lastname}
                                    onChange={handleInputChange}
                                    required
                                    placeholder={t('Nom') + '*'}
                                    aria-label={t("Nom")}
                                    className={formErrors.lastname ? 'error' : ''}
                                    aria-invalid={formErrors.lastname ? 'true' : 'false'}
                                    aria-describedby={formErrors.lastname ? 'error-lastname' : undefined}
                                  />
                                </div>
                                {formErrors.lastname && <FieldError error={formErrors.lastname} id="lastname" />}
                              </div>
                              <div className="formField">
                                <div className="formControl hasInfo">
                                  <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={userData.email}
                                    onChange={handleInputChange}
                                    required
                                    placeholder={t('Email') + '*'}
                                    aria-label={t("Email")}
                                    className={formErrors.email ? 'error' : ''}
                                    aria-invalid={formErrors.email ? 'true' : 'false'}
                                    aria-describedby={formErrors.email ? 'error-email' : undefined}
                                  />
                                  <InfoContent
                                    id="forEmailTransmitter"
                                    infoField={infoField}
                                    showInfo={handleShowInfo}
                                    context="emailStep2"
                                    hideInfo={handleHideInfo}
                                    infoText={
                                      <>
                                        <h3 className="typoMedium">
                                          {userData.isSelfDestination
                                            ? t('La carte cadeau vous sera envoyée par email')
                                            : t('Une copie de la carte cadeau vous sera envoyée par email')}
                                        </h3>
                                        <p>{t('Veuillez privilégier une adresse personnelle car les serveurs professionnels peuvent filtrer les informations commerciales')}</p>
                                      </>
                                    }
                                    ariaLabelShow={t("Informations sur l'email expéditeur")}
                                    ariaLabelHide={t("Fermer les informations")}
                                  />
                                </div>
                                {formErrors.email && <FieldError error={formErrors.email} id="email" />}
                              </div>
                              <div className="formField">
                                <div className="formControl">
                                  <input
                                    type="email"
                                    name="confEmail"
                                    id="confEmail"
                                    value={userData.confEmail}
                                    onChange={handleInputChange}
                                    placeholder={t('Email confirmation') + '*'}
                                    aria-label={t("Email confirmation")}
                                    className={formErrors.confEmail ? 'error' : ''}
                                    aria-invalid={formErrors.confEmail ? 'true' : 'false'}
                                    aria-describedby={formErrors.confEmail ? 'error-confEmail' : undefined}
                                  />
                                </div>
                                {formErrors.confEmail && <FieldError error={formErrors.confEmail} id="confEmail" />}
                              </div>
                              {!store.isProSignboard && store.clientIdType && (
                                <ClientId
                                  userData={userData}
                                  setUserData={setUserData}
                                  formErrors={formErrors}
                                  setFormErrors={setFormErrors}
                                />
                              )}
                            </>
                          )}

                          {/* Champ téléphone avec condition */}
                          {store.phone_enabled && (!store.kycEnabled ||
                            (store.kycEnabled && store.kycs?.buyer_phone &&
                              totalAmounts >= store.kycs.buyer_phone.thresholdPrice)) && (
                              <div className="formField">
                                <div className="formControl">
                                  <input
                                    type="text"
                                    name="phone"
                                    id="phone"
                                    value={userData.phone}
                                    onChange={handleInputChange}
                                    required
                                    placeholder={store.phone_placeholder}
                                    aria-label={t("phone")}
                                    className={formErrors.phone ? 'error' : ''}
                                    aria-invalid={formErrors.phone ? 'true' : 'false'}
                                    aria-describedby={formErrors.phone ? 'error-phone' : undefined}
                                  />
                                </div>
                                {formErrors.phone && <FieldError error={formErrors.phone} id="phone" />}
                              </div>
                            )}


                          {store.isProSignboard && (
                            <div className="formField">
                              <div className="formControl hasInfo">
                                <input
                                  type="text"
                                  name="proIdentification"
                                  id="proIdentification"
                                  value={userData.proIdentification || ''}
                                  onChange={handleInputChange}
                                  required
                                  placeholder={t('Votre identifiant de société') + '*'}
                                  aria-label={t("Votre identifiant de société")}
                                  className={formErrors.proIdentification ? 'error' : ''}
                                  aria-invalid={formErrors.proIdentification ? 'true' : 'false'}
                                  aria-describedby={formErrors.proIdentification ? 'error-proIdentification' : undefined}
                                />
                                <InfoContent
                                  id="forProIdentification"
                                  infoField={infoField}
                                  showInfo={handleShowInfo}
                                  hideInfo={handleHideInfo}
                                  infoText={
                                    <>
                                      <h5 className="typoMedium">
                                        {t(store.proIdentificationType)}
                                      </h5>
                                      <p>
                                        {t('Note: vous devez au préalable avoir communiqué cette information au service Frizbee')}
                                      </p>
                                    </>
                                  }
                                  ariaLabelShow={t("Informations sur l'identifiant de société")}
                                  ariaLabelHide={t("Fermer les informations")}
                                />
                              </div>
                              {formErrors.proIdentification && <FieldError error={formErrors.proIdentification} id="proIdentification" />}
                            </div>
                          )}
                          {/* KYC Fields */}
                          {store.kycEnabled && store.kycs?.buyer_address &&
                            totalAmounts >= store.kycs.buyer_address.thresholdPrice && (
                              <>
                                <div className="formField" id="row_buyer_address_1">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="kyc_address_1"
                                      id="buyer_kyc_address_1"
                                      value={userData.kyc_address_1}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Adresse ligne 1') + '*'}
                                      aria-label={t("Adresse ligne 1")}
                                      className={formErrors.kyc_address_1 ? 'error' : ''}
                                      aria-invalid={formErrors.kyc_address_1 ? 'true' : 'false'}
                                      aria-describedby={formErrors.kyc_address_1 ? 'error-kyc_address_1' : undefined}
                                    />
                                  </div>
                                  {formErrors.kyc_address_1 && <FieldError error={formErrors.kyc_address_1} id="kyc_address_1" />}
                                </div>

                                <div className="formField" id="row_buyer_address_2">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="kyc_address_2"
                                      id="buyer_kyc_address_2"
                                      value={userData.kyc_address_2}
                                      onChange={handleInputChange}
                                      placeholder={t('Complément adresse ligne 2')}
                                      aria-label={t("Complément adresse ligne 2")}

                                    />
                                  </div>
                                </div>

                                {store.nbAddressLine >= 3 && (
                                  <div className="formField" id="row_buyer_address_3">
                                    <div className="formControl">
                                      <input
                                        type="text"
                                        name="kyc_address_3"
                                        id="buyer_kyc_address_3"
                                        value={userData.kyc_address_3}
                                        onChange={handleInputChange}
                                        placeholder={t('Complément adresse ligne 3')}
                                        aria-label={t("Complément adresse ligne 3")}

                                      />
                                    </div>
                                  </div>
                                )}

                                {store.nbAddressLine >= 4 && (
                                  <div className="formField" id="row_buyer_address_4">
                                    <div className="formControl">
                                      <input
                                        type="text"
                                        name="kyc_address_4"
                                        id="buyer_kyc_address_4"
                                        value={userData.kyc_address_4}
                                        onChange={handleInputChange}
                                        placeholder={t('Complément adresse ligne 4')}
                                        aria-label={t("Complément adresse ligne 4")}

                                      />
                                    </div>
                                  </div>
                                )}

                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="kyc_postalCode"
                                      id="buyer_kyc_postalCode"
                                      value={userData.kyc_postalCode}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Code postal') + '*'}
                                      aria-label={t("Code postal")}
                                      className={formErrors.kyc_postalCode ? 'error' : ''}
                                      aria-invalid={formErrors.kyc_postalCode ? 'true' : 'false'}
                                      aria-describedby={formErrors.kyc_postalCode ? 'error-kyc_postalCode' : undefined}
                                    />
                                  </div>
                                  {formErrors.kyc_postalCode && <FieldError error={formErrors.kyc_postalCode} id="kyc_postalCode" />}
                                </div>

                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="kyc_city"
                                      id="buyer_kyc_city"
                                      value={userData.kyc_city}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Ville') + '*'}
                                      aria-label={t("Ville")}
                                      className={formErrors.kyc_city ? 'error' : ''}
                                      aria-invalid={formErrors.kyc_city ? 'true' : 'false'}
                                      aria-describedby={formErrors.kyc_city ? 'error-kyc_city' : undefined}
                                    />
                                  </div>
                                  {formErrors.kyc_city && <FieldError error={formErrors.kyc_city} id="kyc_city" />}
                                </div>

                                {store.isStateEnabled && (
                                  <div className="formField">
                                    <div className="formControl">
                                      <select
                                        id="buyer_kyc_state"
                                        name="kyc_state"
                                        value={userData.kyc_state}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          {store.physical_store?.texts?.state_list_label?.[lang]}
                                        </option>
                                        {store.physical_store?.states?.map(state => (
                                          <option key={state.code} value={state.code}>
                                            {getStateName(state)}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                )}

                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="kyc_country"
                                      id="buyer_kyc_country"
                                      value={userData.kyc_country}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Pays') + '*'}
                                      aria-label={t("Pays")}
                                      className={formErrors.kyc_country ? 'error' : ''}
                                      aria-invalid={formErrors.kyc_country ? 'true' : 'false'}
                                      aria-describedby={formErrors.kyc_country ? 'error-kyc_country' : undefined}
                                    />
                                  </div>
                                  {formErrors.kyc_country && <FieldError error={formErrors.kyc_country} id="kyc_country" />}
                                </div>
                              </>
                            )}

                          {/* Facturation */}
                          {!store.isProSignboard && (store.sending_invoice_activated === 1 || store.sending_invoice_activated === 3) && (
                            <div className="formField">
                              <div className="formControl blockOptions customCheckbox">
                                <div className="optionItem">
                                  <input
                                    type="checkbox"
                                    name="isGettingInvoiceActivated"
                                    id="isGettingInvoiceActivated"
                                    checked={userData.isGettingInvoiceActivated}
                                    onChange={handleInputChange}
                                  />
                                  <label htmlFor="isGettingInvoiceActivated">
                                    {store.sending_invoice_activated === 1
                                      ? t('Obtenir une facture')
                                      : store.sending_invoice_activated === 3
                                        ? <span dangerouslySetInnerHTML={{ __html: store.invoiceProfessionalTick?.[lang] }} />
                                        : null
                                    }
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                          {/*         {!store.isProSignboard && store.tax_id_position === 0 &&
                            (!store.kycEnabled || (store.kycEnabled && store.kycs?.buyer_taxid !== undefined &&
                              totalAmounts >= store.kycs.buyer_taxid.thresholdPrice)) && (
                              <TaxId
                                store={store}
                                userData={userData}
                                setUserData={setUserData}
                                showInfo={handleShowInfo}
                                hideInfo={handleHideInfo}
                                infoField={infoField}
                                formErrors={formErrors}
                              />
                            )} */}
                          {/* Afficher les champs de facturation si activé */}
                          {!store.isProSignboard && store.sending_invoice_activated > 0 &&
                            (store.sending_invoice_activated === 2 || userData.isGettingInvoiceActivated) && (
                              <>
                                {/* Champs TaxId et VAT selon leur position */}
                                {store.tax_id_position === 1 && (
                                  <TaxId
                                    store={store}
                                    userData={userData}
                                    setUserData={setUserData}
                                    showInfo={handleShowInfo}
                                    hideInfo={handleHideInfo}
                                    infoField={infoField}
                                    formErrors={formErrors}
                                    setFormErrors={setFormErrors}
                                  />
                                )}

                                {store.vat_position === 1 && (
                                  <VAT
                                    store={store}
                                    userData={userData}
                                    setUserData={setUserData}
                                    showInfo={handleShowInfo}
                                    hideInfo={handleHideInfo}
                                    infoField={infoField}
                                    formErrors={formErrors}
                                    setFormErrors={setFormErrors}
                                  />
                                )}

                                {/* Champ Entreprise uniquement pour le cas 3 */}
                                {store.sending_invoice_activated === 3 && (
                                  <div className="formField">
                                    <div className="formControl">
                                      <input
                                        type="text"
                                        name="companyTransmitter"
                                        id="companyTransmitter"
                                        value={userData.companyTransmitter}
                                        onChange={handleInputChange}
                                        required
                                        placeholder={t('Entreprise') + '*'}
                                        aria-label={t("Entreprise")}
                                        className={formErrors.companyTransmitter ? 'error' : ''}
                                        aria-invalid={formErrors.companyTransmitter ? 'true' : 'false'}
                                        aria-describedby={formErrors.companyTransmitter ? 'error-companyTransmitter' : undefined}
                                      />
                                    </div>
                                    {formErrors.companyTransmitter && <FieldError error={formErrors.companyTransmitter} id="companyTransmitter" />}
                                  </div>
                                )}

                                {/* Les champs d'adresse communs */}

                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="addressTransmitter"
                                      id="addressTransmitter"
                                      value={userData.addressTransmitter}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Adresse') +
                                        (store.sending_invoice_activated === 2 || userData.isGettingInvoiceActivated ? '*' : '')}
                                      aria-label={t("Adresse")}
                                      className={formErrors.addressTransmitter ? 'error' : ''}
                                      aria-invalid={formErrors.addressTransmitter ? 'true' : 'false'}
                                      aria-describedby={formErrors.addressTransmitter ? 'error-addressTransmitter' : undefined}
                                    />
                                  </div>
                                  {formErrors.addressTransmitter && <FieldError error={formErrors.addressTransmitter} id="addressTransmitter" />}
                                </div>

                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="addressComplementTransmitter"
                                      id="addressComplementTransmitter"
                                      value={userData.addressComplementTransmitter || ''}
                                      onChange={handleInputChange}
                                      required // Ajout de l'attribut required comme dans la version AngularJS
                                      placeholder={t('Complément adresse')}
                                      aria-label={t("Complément adresse")}
                                      className={formErrors?.addressComplementTransmitter ? 'error' : ''}
                                      aria-invalid={formErrors?.addressComplementTransmitter ? 'true' : 'false'}
                                      aria-describedby={formErrors?.addressComplementTransmitter ? 'error-addressComplementTransmitter' : undefined}
                                    />
                                  </div>
                                  {formErrors?.addressComplementTransmitter && (
                                    <div className="field-error" id="error-addressComplementTransmitter" role="alert">
                                      <span className="error-icon" aria-hidden="true">⚠️</span>
                                      <span className="error-message">{formErrors.addressComplementTransmitter}</span>
                                    </div>
                                  )}
                                </div>
                                {/* Adresses complémentaires selon nbAddressLine */}
                                {store.nbAddressLine >= 3 && (
                                  <div className="formField">
                                    <div className="formControl">
                                      <input
                                        type="text"
                                        name="addressComplementTransmitter1"
                                        id="addressComplementTransmitter1"
                                        value={userData.addressComplementTransmitter1}
                                        onChange={handleInputChange}
                                        placeholder={t('Complément adresse1')}
                                        aria-label={t("Complément adresse1")}

                                      />
                                    </div>
                                  </div>
                                )}

                                {store.nbAddressLine >= 4 && (
                                  <div className="formField">
                                    <div className="formControl">
                                      <input
                                        type="text"
                                        name="addressComplementTransmitter2"
                                        id="addressComplementTransmitter2"
                                        value={userData.addressComplementTransmitter2}
                                        onChange={handleInputChange}
                                        placeholder={t('Complément adresse2')}
                                        aria-label={t("Complément adresse2")}

                                      />
                                    </div>
                                  </div>
                                )}
                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="postalCode"
                                      id="postalCode"
                                      value={userData.postalCode}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Code postal') +
                                        (store.sending_invoice_activated === 2 || userData.isGettingInvoiceActivated ? '*' : '')}
                                      aria-label={t("Code postal")}
                                      className={formErrors.postalCode ? 'error' : ''}
                                      aria-invalid={formErrors.postalCode ? 'true' : 'false'}
                                      aria-describedby={formErrors.postalCode ? 'error-postalCode' : undefined}
                                    />
                                  </div>
                                  {formErrors.postalCode && <FieldError error={formErrors.postalCode} id="postalCode" />}
                                </div>
                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="city"
                                      id="city"
                                      value={userData.city}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Ville') +
                                        (store.sending_invoice_activated === 2 || userData.isGettingInvoiceActivated ? '*' : '')}
                                      aria-label={t("Ville")}
                                      className={formErrors.city ? 'error' : ''}
                                      aria-invalid={formErrors.city ? 'true' : 'false'}
                                      aria-describedby={formErrors.city ? 'error-city' : undefined}
                                    />
                                  </div>
                                  {formErrors.city && <FieldError error={formErrors.city} id="city" />}
                                </div>
                                {/* Select pour state si activé */}
                                {store.isStateEnabled && (
                                  <div className="formField">
                                    <div className="formControl">
                                      <select
                                        id="state"
                                        name="state"
                                        value={userData.state}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          {store.physical_store?.texts?.state_list_label?.[lang]}
                                        </option>
                                        {store.physical_store?.states?.map(state => (
                                          <option key={state.code} value={state.code}>
                                            {getStateName(state)}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                )}
                                <div className="formField">
                                  <div className="formControl">
                                    <input
                                      type="text"
                                      name="country"
                                      id="country"
                                      value={userData.country}
                                      onChange={handleInputChange}
                                      required
                                      placeholder={t('Pays') +
                                        (store.sending_invoice_activated === 2 || userData.isGettingInvoiceActivated ? '*' : '')}
                                      aria-label={t("Pays")}
                                      className={formErrors.country ? 'error' : ''}
                                      aria-invalid={formErrors.country ? 'true' : 'false'}
                                      aria-describedby={formErrors.country ? 'error-country' : undefined}
                                    />
                                  </div>
                                  {formErrors.country && <FieldError error={formErrors.country} id="country" />}
                                </div>
                              </>
                            )}
                          {/* Validation CGV et Newsletter */}
                          <div className="formField">
                            <div className="formField">
                              <div className="formControl blockOptions customCheckbox">
                                <div className="customCheckbox optionItem">
                                  <input
                                    type="checkbox"
                                    name="accepteCGV"
                                    id="accepteCGV"
                                    checked={userData.accepteCGV}
                                    onChange={handleInputChange}
                                    className={formErrors.accepteCGV ? 'error' : ''}
                                    aria-invalid={formErrors.accepteCGV ? 'true' : 'false'}
                                  />
                                  <label htmlFor="accepteCGV" className={formErrors.accepteCGV ? 'error-label' : ''}>
                                    {t("J'accepte")}{' '}
                                    {store.cgvExternalLink && store.cgvExternalLink[lang] && store.cgvExternalLink[lang] !== '' ? (
                                      <a
                                        href={store.cgvExternalLink[lang]}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mainColor"
                                        aria-label={t('les conditions générales de ventes')}
                                      >
                                        {t('les conditions générales de ventes')}
                                      </a>
                                    ) : (
                                        <a
                                          href="/CGV"
                                          className="mainColor"
                                          aria-label={t('les conditions générales de ventes')}
                                        >
                                          {t('les conditions générales de ventes')}
                                        </a>
                                      )}{' '}
                                    {t('et')}{' '}
                                    {store.cguExternalLink && store.cguExternalLink[lang] && store.cguExternalLink[lang] !== '' ? (
                                      <a
                                        href={store.cguExternalLink[lang]}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mainColor"
                                        aria-label={t("les conditions générales d’utilisation")}
                                      >
                                        {t("les conditions générales d’utilisation")}
                                      </a>
                                    ) : (
                                        <a
                                          href="/CGU"
                                          className="mainColor"
                                          aria-label={t("les conditions générales d’utilisation")}
                                        >
                                          {t("les conditions générales d’utilisation")}
                                        </a>
                                      )}{' '}
                                    {t('de la carte cadeaux')} {store.libelle}*
                            </label>
                                </div>
                              </div>
                              {formErrors.accepteCGV && <FieldError error={formErrors.accepteCGV} id="accepteCGV" />}

                              {store.opt_in && (
                                <div className="formControl blockOptions customCheckbox">
                                  <div className="optionItem">
                                    <input
                                      type="checkbox"
                                      name="accepteNL"
                                      id="userAccepteNL"
                                      checked={userData.accepteNL}
                                      onChange={handleInputChange}
                                    />
                                    <label htmlFor="userAccepteNL">
                                      {t("J'accepte de recevoir des informations de la part de")} {store.libelle}
                                    </label>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Messages d'erreur */}
                            <div className="fieldsGroup">
                              <div className="whitebox">
                                {t("Les champs marqués d'un astérisque (*) sont obligatoires")}
                              </div>
                              {Object.values(formErrors).some(error => error) && (
                                <div className="errorBox" role="alert" aria-live="polite">
                                  <div className="error-summary">
                                    <span className="error-icon" aria-hidden="true">⚠️</span>
                                    <span className="error-title">{t("Veuillez corriger les erreurs suivantes :")}</span>
                                    <ul>
                                      {Object.entries(formErrors).map(([key, message]) =>
                                        message ? <li key={key}>{message}</li> : null
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>


                          <div className="actionsRow labelMargin">
                            {cart.items?.length > 0 && (
                              <input style={{ width: '100%', marginTop: 5, marginBottom: 10 }}
                                type="submit"
                                name="submit"
                                id="submitOrder"
                                className="btn sendOrder"
                                value={t('Valider mon achat')}
                              />
                            )}
                            {cart.items?.length > 0 && (
                              <input
                                style={{ minWidth: '100%' }}
                                type="button"
                                name="buyOther"
                                id="buyOtherCard"
                                className="btn buyOther"
                                onClick={() => goToStep(1)}
                                value={t('Acheter une autre carte')}
                              />
                            )}
                            {store.isAmexAvailable && cart.useAmex && (
                              <div className="amexText">
                                <span>{t('Je régle mon achat avec ma carte American Express')}</span>
                                <img src="assets/images/amex.jpg" className="amexLogo" alt="Amex" />
                              </div>
                            )}

                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </form>
            )}
            <div style={{ display: step === "payment" ? 'block' : 'none' }} id="paymentHtml">
              {pspType === 'local-form' && paymentHtml && (
                <PaymentFormLocal htmlInfo={paymentHtml} />
              )}

            </div>
          </div>


          {/* Formulaire caché pour le mode redirect ou overlay */}
          {(store.PSP_TYPE === 'redirect' || store.PSP_TYPE === 'overlay') && (
            <form
              id="paymentForm"
              method="post"
              acceptCharset={store.PSP === 'Inicis' ? 'euc-kr' : undefined}
              noValidate
              aria-hidden="true"
              style={{ display: 'none' }}
            >
              <div className="paymentData">
                {Object.keys(store.PSP_fields || {}).map(key => (
                  <input
                    key={key}
                    id={key}
                    type="hidden"
                    name={key}
                  />
                ))}
              </div>
            </form>
          )}

        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <Modal
          modalType={modalType}
          onHideModal={() => {
            setShowModal(false);
            setModalType(null);
            setItemToDelete(null);
          }}
          onDeleteItem={(key) => {
            deleteRequestCartItem(key);
            setShowModal(false);
            setModalType(null);
            setItemToDelete(null);
          }}
          itemToDelete={itemToDelete}
          store={store}
        />
      )}
      {modalUpdateOpen && (
        <UpdateCardModal
          card={cardToUpdate}
          index={cardIndex}
          store={store}
          mode={modalUpdateType}
          onClose={() => setModalUpdateOpen(false)}
        />
      )}

    </div>
  );
};


export default Step2;
